/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Biaya_S2Inputs */

const en_mk_tut_biaya_s2 = /** @type {(inputs: Mk_Tut_Biaya_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a **spending cap** on each agent’s page. When the cap is reached the agent stops taking new tasks instead of quietly burning the budget.`)
};

const id_mk_tut_biaya_s2 = /** @type {(inputs: Mk_Tut_Biaya_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasang **batas belanja** di halaman setiap agen. Kalau batas tercapai, agen berhenti mengambil tugas baru, bukan diam-diam menghabiskan anggaran.`)
};

/**
* | output |
* | --- |
* | "Set a **spending cap** on each agent’s page. When the cap is reached the agent stops taking new tasks instead of quietly burning the budget." |
*
* @param {Mk_Tut_Biaya_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_biaya_s2 = /** @type {((inputs?: Mk_Tut_Biaya_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Biaya_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_biaya_s2(inputs)
	return en_mk_tut_biaya_s2(inputs)
});